import { useCallback, useEffect, useState } from "react";
import useCarouselApi from "./useCarouselApi";
const useSlidesInView = (carouselId, memorizePrevious = false) => {
  const carouselApi = useCarouselApi(carouselId);
  const [slidesInView, setSlidesInView] = useState([]);
  const updateSlidesInView = useCallback(() => {
    setSlidesInView((cur) => {
      if (cur.length === carouselApi.slideNodes().length) {
        carouselApi.off("slidesInView", updateSlidesInView);
      }
      const inView = carouselApi.slidesInView();
      if (memorizePrevious) {
        return cur.concat(inView.filter((index) => !cur.includes(index)));
      }
      return inView;
    });
  }, [carouselApi, memorizePrevious]);
  useEffect(() => {
    if (!carouselApi) return;
    updateSlidesInView();
    carouselApi.on("slidesInView", () => {
      updateSlidesInView();
    });
  }, [carouselApi, updateSlidesInView]);
  return slidesInView;
};
export default useSlidesInView;
